/**
 * Singleton @metabus/esign-client instance for the operator app.
 *
 * Same Firebase-ID-token bearer flow every other lib/api/*.ts file in this
 * app uses (see src/lib/api/aiDrafts.ts, src/lib/api/client.ts) — the dialer
 * backend's `get_documenso_caller` seam (buildgravity-dialer/docs/
 * documenso-api-contract.md "Auth model") admits an `is_super_admin=true`
 * Firebase user, which is exactly what `auth.currentUser` is when this app's
 * own /api/me resolution has already gated the route (see
 * src/pages/ESignPage.tsx).
 */

import { createEsignClient } from '@metabus/esign-client';
import { auth } from './firebase';

const API_BASE_URL = import.meta.env.VITE_API_URL || 'https://sales-api-768596480524.us-central1.run.app';

export const esignClient = createEsignClient({
  baseUrl: API_BASE_URL,
  getToken: async () => {
    const user = auth.currentUser;
    if (!user) return null;
    return user.getIdToken();
  },
});
